import { configStore } from '@vfde-sails/core';
import './style.scss';
import app from './container/App';

configStore({}) && app();
